module.exports = __webpack_public_path__ + "public-ui/img/mts.21c393bb.svg";